import { ReactElement } from 'react';
import { Box, Flex } from 'reflexbox';
import { HexColorPicker, HexColorInput } from 'react-colorful';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { SubSectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import Label from 'packages/kakapo-ui-kit/components/forms/controls/Label';

const StyledHexColorInput = styled(HexColorInput)`
	padding: 8px 16px;
	border: 1px solid #eee;
`;

interface Props {
	label: string;
	color: string;
	setColor: (value: string) => void;
}

export default function ColorPicker({ label, color, setColor }: Props): ReactElement {
	const { t } = useTranslation();
	return (
		<Box justifyContent="stretch" alignItems="stretch">
			<SubSectionTitle>{label}</SubSectionTitle>
			<HexColorPicker color={color} onChange={setColor} />
			<Flex flexDirection="column" alignItems="stretch" mt={2}>
				<Label title={t('common.colorInHex')} />
				<StyledHexColorInput color={color} onChange={setColor} />
			</Flex>
		</Box>
	);
}
